module.exports = __webpack_public_path__ + "static/media/paper-clip.67d025b3.svg";